import React, { useState } from "react";
import {
  Alert,
  Box,
  Button,
  Checkbox,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Divider,
  FormControlLabel,
  Grid,
  IconButton,
  InputAdornment,
  Snackbar,
  Step,
  StepLabel,
  Stepper,
  TextField,
  Typography,
} from "@mui/material";
import VisibilityIcon from "@mui/icons-material/Visibility";
import VisibilityOffIcon from "@mui/icons-material/VisibilityOff";

import OperatingHours from "./OperatingHours";
import ContactInfo from "./ContactInfo";

// when empty, zip validation is skipped
const ACCEPTED_ZIP_CODES = [
  "90001",
  "90004",
  "90005",
  "90006",
  "90007",
  "90011",
  "90012",
  "90013",
  "90015",
  "90016",
  "90017",
  "90018",
  "90019",
  "90020",
  "90021",
  "90024",
  "90025",
  "90026",
  "90027",
  "90028",
  "90029",
  "90031",
  "90033",
  "90034",
  "90035",
  "90036",
  "90038",
  "90039",
  "90042",
  "90043",
  "90045",
  "90046",
  "90048",
  "90049",
  "90058",
  "90064",
  "90066",
  "90067",
  "90069",
  "90071",
  "90089",
  "90094",
  "90095",
  "90210",
  "90212",
  "90232",
  "90245",
  "90248",
  "90260",
  "90266",
  "90270",
  "90274",
  "90277",
  "90278",
  "90280",
  "90291",
  "90292",
  "90293",
  "90301",
  "90401",
  "90403",
  "90405",
  "90505",
  "90601",
  "90602",
  "90631",
  "90706",
  "90712",
  "90731",
  "90745",
  "90802",
  "90803",
  "90804",
  "90807",
  "90808",
  "90814",
  "91006",
  "91007",
  "91030",
  "91103",
  "91107",
  "91204",
  "91206",
  "91302",
  "91307",
  "91311",
  "91320",
  "91324",
  "91325",
  "91351",
  "91352",
  "91355",
  "91356",
  "91360",
  "91362",
  "91364",
  "91403",
  "91423",
  "91505",
  "91601",
  "91605",
  "91723",
  "91748",
  "91750",
  "91763",
  "91768",
  "91786",
  "91801",
  "92821",
  "92832",
  "92833",
  "93001",
  "93003",
  "93010",
  "93012",
  "93013",
  "93023",
  "93030",
  "93033",
  "93035",
  "93065",
  "93067",
  "93101",
  "93103",
  "93105",
  "93108",
  "93109",
  "93111",
  "93117",
];

const COMMON_PASSWORDS = [
  "123456",
  "password",
  "12345678",
  "1234",
  "pussy",
  "12345",
  "dragon",
  "qwerty",
  "696969",
  "mustang",
  "letmein",
  "baseball",
  "master",
  "michael",
  "football",
  "shadow",
  "monkey",
  "abc123",
  "pass",
  "6969",
  "jordan",
  "harley",
  "ranger",
  "iwantu",
  "jennifer",
  "hunter",
  "2000",
  "test",
  "batman",
  "trustno1",
  "thomas",
  "tigger",
  "robert",
  "access",
  "love",
  "buster",
  "1234567",
  "soccer",
  "hockey",
  "killer",
  "george",
  "sexy",
  "andrew",
  "charlie",
  "superman",
  "asshole",
  "dallas",
  "jessica",
  "panties",
  "pepper",
  "1111",
  "austin",
  "william",
  "daniel",
  "golfer",
  "summer",
  "heather",
  "hammer",
  "yankees",
  "joshua",
  "maggie",
  "biteme",
  "enter",
  "ashley",
  "thunder",
  "cowboy",
  "silver",
  "richard",
  "orange",
  "merlin",
  "michelle",
  "corvette",
  "bigdog",
  "cheese",
  "matthew",
  "121212",
  "patrick",
  "martin",
  "freedom",
  "ginger",
  "blowjob",
  "nicole",
  "sparky",
  "yellow",
  "camaro",
  "secret",
  "dick",
  "falcon",
  "taylor",
  "111111",
  "131313",
  "123123",
  "bitch",
  "hello",
  "scooter",
  "please",
  "porsche",
  "guitar",
  "chelsea",
  "black",
  "diamond",
  "nascar",
  "jackson",
  "cameron",
  "654321",
  "computer",
  "amanda",
  "wizard",
  "xxxxxxxx",
  "money",
  "phoenix",
  "mickey",
  "bailey",
  "knight",
  "iceman",
  "tigers",
  "purple",
  "andrea",
  "horny",
  "dakota",
  "aaaaaa",
  "player",
  "sunshine",
  "morgan",
  "starwars",
  "boomer",
  "cowboys",
  "edward",
  "charles",
  "girls",
  "booboo",
  "coffee",
  "xxxxxx",
  "bulldog",
  "ncc1701",
  "rabbit",
  "peanut",
  "john",
  "johnny",
  "gandalf",
  "spanky",
  "winter",
  "brandy",
  "compaq",
  "carlos",
  "tennis",
  "james",
  "mike",
  "brandon",
  "fender",
  "anthony",
  "blowme",
  "ferrari",
  "cookie",
  "chicken",
  "maverick",
  "chicago",
  "joseph",
  "diablo",
  "sexsex",
  "hardcore",
  "666666",
  "willie",
  "welcome",
  "chris",
  "panther",
  "yamaha",
  "justin",
  "banana",
  "driver",
  "marine",
  "angels",
  "fishing",
  "david",
  "maddog",
  "hooters",
  "wilson",
  "butthead",
  "dennis",
  "captain",
  "bigdick",
  "chester",
  "smokey",
  "xavier",
  "steven",
  "viking",
  "snoopy",
  "blue",
  "eagles",
  "winner",
  "samantha",
  "house",
  "miller",
  "flower",
  "jack",
  "firebird",
  "butter",
  "united",
  "turtle",
  "steelers",
  "tiffany",
  "zxcvbn",
  "tomcat",
  "golf",
  "bond007",
  "bear",
  "tiger",
  "doctor",
  "gateway",
  "gators",
  "angel",
  "junior",
  "thx1138",
  "porno",
  "badboy",
  "debbie",
  "spider",
  "melissa",
  "booger",
  "1212",
  "flyers",
  "fish",
  "porn",
  "matrix",
  "teens",
  "scooby",
  "jason",
  "walter",
  "cumshot",
  "boston",
  "braves",
  "yankee",
  "lover",
  "barney",
  "victor",
  "tucker",
  "princess",
  "mercedes",
  "5150",
  "doggie",
  "zzzzzz",
  "gunner",
  "horney",
  "bubba",
  "2112",
  "fred",
  "johnson",
  "xxxxx",
  "tits",
  "member",
  "boobs",
  "donald",
  "bigdaddy",
  "bronco",
  "penis",
  "voyager",
  "rangers",
  "birdie",
  "trouble",
  "white",
  "topgun",
  "bigtits",
  "bitches",
  "green",
  "super",
  "qazwsx",
  "magic",
  "lakers",
  "rachel",
  "slayer",
  "scott",
  "2222",
  "asdf",
  "video",
  "london",
  "7777",
  "marlboro",
  "srinivas",
  "internet",
  "action",
  "carter",
  "jasper",
  "monster",
  "teresa",
  "jeremy",
  "11111111",
  "bill",
  "crystal",
  "peter",
  "pussies",
  "cock",
  "beer",
  "rocket",
  "theman",
  "oliver",
  "prince",
  "beach",
  "amateur",
  "7777777",
  "muffin",
  "redsox",
  "star",
  "testing",
  "shannon",
  "murphy",
  "frank",
  "hannah",
  "dave",
  "eagle1",
  "11111",
  "mother",
  "nathan",
  "raiders",
  "steve",
  "forever",
  "angela",
  "viper",
  "ou812",
  "jake",
  "lovers",
  "suckit",
  "gregory",
  "buddy",
  "whatever",
  "young",
  "nicholas",
  "lucky",
  "helpme",
  "jackie",
  "monica",
  "midnight",
  "college",
  "baby",
  "brian",
  "mark",
  "startrek",
  "sierra",
  "leather",
  "232323",
  "4444",
  "beavis",
  "bigcock",
  "happy",
  "sophie",
  "ladies",
  "naughty",
  "giants",
  "booty",
  "blonde",
  "golden",
  "fire",
  "sandra",
  "pookie",
  "packers",
  "einstein",
  "dolphins",
  "chevy",
  "winston",
  "warrior",
  "sammy",
  "slut",
  "8675309",
  "zxcvbnm",
  "nipples",
  "power",
  "victoria",
  "asdfgh",
  "vagina",
  "toyota",
  "travis",
  "hotdog",
  "paris",
  "rock",
  "xxxx",
  "extreme",
  "redskins",
  "erotic",
  "dirty",
  "ford",
  "freddy",
  "arsenal",
  "access14",
  "wolf",
  "nipple",
  "iloveyou",
  "alex",
  "florida",
  "eric",
  "legend",
  "movie",
  "success",
  "rosebud",
  "jaguar",
  "great",
  "cool",
  "cooper",
  "1313",
  "scorpio",
  "mountain",
  "madison",
  "987654",
  "brazil",
  "lauren",
  "japan",
  "naked",
  "squirt",
  "stars",
  "apple",
  "alexis",
  "aaaa",
  "bonnie",
  "peaches",
  "jasmine",
  "kevin",
  "matt",
  "qwertyui",
  "danielle",
  "beaver",
  "4321",
  "4128",
  "runner",
  "swimming",
  "dolphin",
  "gordon",
  "casper",
  "stupid",
  "shit",
  "saturn",
  "gemini",
  "apples",
  "august",
  "3333",
  "canada",
  "blazer",
  "cumming",
  "hunting",
  "kitty",
  "rainbow",
  "112233",
  "arthur",
  "cream",
  "calvin",
  "shaved",
  "surfer",
  "samson",
  "kelly",
  "paul",
  "mine",
  "king",
  "racing",
  "5555",
  "eagle",
  "hentai",
  "newyork",
  "little",
  "redwings",
  "smith",
  "sticky",
  "cocacola",
  "animal",
  "broncos",
  "private",
  "skippy",
  "marvin",
  "blondes",
  "enjoy",
  "girl",
  "apollo",
  "parker",
  "qwert",
  "time",
  "sydney",
  "women",
  "voodoo",
  "magnum",
  "juice",
  "abgrtyu",
  "777777",
  "dreams",
  "maxwell",
  "music",
  "rush2112",
  "russia",
  "scorpion",
  "rebecca",
  "tester",
  "mistress",
  "phantom",
  "billy",
  "6666",
  "albert",
];

const isEmailValid = (val) => /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(val);

const isPwdLongEnough = (pwd) => pwd.length >= 8;
const isPwdNotOnlyNumbers = (pwd) => pwd.length === 0 || !/^\d+$/.test(pwd);
const isPwdNotCommon = (pwd) =>
  pwd.length <= 3 ||
  !COMMON_PASSWORDS.some((w) => pwd.toLowerCase().includes(w));
const isPwdNotSimilarToEmail = (pwd, email) => {
  if (pwd.length <= 3) return true;
  const p = pwd.toLowerCase();
  return (
    !email.toLowerCase().includes(p) &&
    !p.includes(email.toLowerCase().split("@")[0])
  );
};

const isPasswordValid = (pwd, email) =>
  isPwdLongEnough(pwd) &&
  isPwdNotOnlyNumbers(pwd) &&
  isPwdNotCommon(pwd) &&
  isPwdNotSimilarToEmail(pwd, email);

const STEPS = ["Restaurant", "Account", "Addresses", "Hours"];

const INITIAL_HOURS = {
  mon: null,
  tue: null,
  wed: null,
  thu: null,
  fri: null,
  sat: null,
  sun: null,
};

const INITIAL_ADDRESS = {
  address_line1: "",
  address_line2: "",
  city: "",
  state: "",
  zip: "",
};

const SignUpForm = ({ onSwitchToSignIn, onRegister }) => {
  const [activeStep, setActiveStep] = useState(0);

  const [email, setEmail] = useState("");
  const [phone, setPhone] = useState("");
  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [pwdVisible, setPwdVisible] = useState(false);
  const [confirmPwdVisible, setConfirmPwdVisible] = useState(false);

  const [restaurantName, setRestaurantName] = useState("");
  const [restaurantZip, setRestaurantZip] = useState("");
  const [restaurantZipError, setRestaurantZipError] = useState(false);

  const [shippingAddress, setShippingAddress] = useState(INITIAL_ADDRESS);
  const [billingAddress, setBillingAddress] = useState(INITIAL_ADDRESS);
  const [billingSameAsShipping, setBillingSameAsShipping] = useState(false);
  const [shippingZipError, setShippingZipError] = useState(false);
  const [snackMessage, setSnackMessage] = useState("");

  const [operatingHours, setOperatingHours] = useState(INITIAL_HOURS);

  const [submitError, setSubmitError] = useState("");
  const [confirmLeaveOpen, setConfirmLeaveOpen] = useState(false);
  const [showErrors, setShowErrors] = useState(false);

  const [saving, setSaving] = useState(false);

  const handleEmailChange = (e) => {
    setEmail(e.target.value);
  };

  const isZipAccepted = (zip) =>
    ACCEPTED_ZIP_CODES.length === 0 || ACCEPTED_ZIP_CODES.includes(zip.trim());

  const emailError = email.length > 0 && !isEmailValid(email);
  const confirmPasswordError =
    confirmPassword.length > 0 && password !== confirmPassword;

  const stepValid = () => {
    if (activeStep === 0)
      return (
        restaurantName.length > 0 &&
        restaurantZip.length > 0 &&
        !restaurantZipError
      );
    if (activeStep === 1)
      return (
        isEmailValid(email) &&
        phone.length > 0 &&
        isPasswordValid(password, email) &&
        password === confirmPassword
      );
    if (activeStep === 2) {
      const shippingFilled =
        shippingAddress.address_line1 &&
        shippingAddress.city &&
        shippingAddress.state &&
        shippingAddress.zip &&
        !shippingZipError;
      const billingFilled =
        billingSameAsShipping ||
        (billingAddress.address_line1 &&
          billingAddress.city &&
          billingAddress.state &&
          billingAddress.zip);
      return shippingFilled && billingFilled;
    }
    return true;
  };

  const hasFormData = () =>
    email ||
    phone ||
    password ||
    restaurantName ||
    restaurantZip ||
    shippingAddress.address_line1 ||
    shippingAddress.city;

  const handleSwitchToSignIn = () => {
    if (hasFormData()) {
      setConfirmLeaveOpen(true);
    } else {
      onSwitchToSignIn();
    }
  };

  const handleConfirmLeave = () => {
    setConfirmLeaveOpen(false);
    setActiveStep(0);
    setEmail("");
    setPhone("");
    setPassword("");
    setConfirmPassword("");
    setRestaurantName("");
    setRestaurantZip("");
    setRestaurantZipError("");
    setShippingAddress(INITIAL_ADDRESS);
    setBillingAddress(INITIAL_ADDRESS);
    setBillingSameAsShipping(false);
    setShippingZipError("");
    setOperatingHours(INITIAL_HOURS);
    setSubmitError("");
    onSwitchToSignIn();
  };

  const copyPhone = (type = null) => {
    if (!type) {
      navigator.clipboard.writeText("323-653-5900");
    } else {
      navigator.clipboard.writeText("626-788-3663");
    }

    setSnackMessage("Phone number copied to clipboard");
  };

  const zipErrorContent = (
    <span>
      Shipping is currently not supported for your address. Friendly Foods only
      ships to select zip codes in the Greater Los Angeles area. Please reach
      out to us at{" "}
      <a href="mailto:orders@friendly-foods.com" style={{ color: "inherit" }}>
        orders@friendly-foods.com
      </a>{" "}
      or{" "}
      <span
        onClick={copyPhone}
        style={{ cursor: "pointer", textDecoration: "underline" }}
      >
        323-653-5900
      </span>{" "}
      for any questions. We would love to help!
    </span>
  );

  const handleRestaurantZipChange = (e) => {
    const zip = e.target.value;
    setRestaurantZip(zip);
    setRestaurantZipError(zip && !isZipAccepted(zip));
  };

  const handleShippingChange = (field) => (e) => {
    const updated = { ...shippingAddress, [field]: e.target.value };
    setShippingAddress(updated);
    if (field === "zip") {
      setShippingZipError(e.target.value && !isZipAccepted(e.target.value));
    }
    if (billingSameAsShipping) setBillingAddress(updated);
  };

  const handleBillingSameToggle = (e) => {
    setBillingSameAsShipping(e.target.checked);
    if (e.target.checked) setBillingAddress(shippingAddress);
  };

  const handleNext = () => {
    setShowErrors(false);
    setActiveStep((s) => s + 1);
  };
  const handleBack = () => {
    setShowErrors(false);
    setActiveStep((s) => s - 1);
  };

  const handleAdvance = () => {
    if (stepValid()) {
      setShowErrors(false);
      activeStep < STEPS.length - 1 ? handleNext() : handleSubmit();
    } else {
      setShowErrors(true);
    }
  };

  const reqErr = (val) => showErrors && !val;
  const reqMsg = (val) => (showErrors && !val ? "Required" : "");

  const handleSubmit = async () => {
    setSubmitError("");
    setSaving(true);

    try {
      await onRegister({
        email,
        phone,
        password,
        confirmPassword,
        restaurantName,
        zipCode: restaurantZip,
        shippingAddress,
        billingAddress: billingSameAsShipping
          ? shippingAddress
          : billingAddress,
        operatingHours,
      }).then(() => {
        setSaving(false);
        handleConfirmLeave();
      });
    } catch (err) {
      let errorMsg = "";

      if (err.response?.data) {
        const data = err.response.data;

        if (typeof data === "string") {
          errorMsg = data;
        } else if (typeof data === "object") {
          errorMsg = Object.entries(data)
            .map(([field, msgs]) => `${field}: ${msgs.join(", ")}`)
            .join("\n");
        } else {
          errorMsg = "An unknown error occurred.";
        }
      }

      setSubmitError(
        `There was an error creating your account. Please try again. ${errorMsg ? "\n\n" + errorMsg : ""}`,
      );
      setSaving(false);
    }
  };

  const stepTitles = {
    0: "Your restaurant",
    1: "Create your account",
    2: "Addresses",
    3: "Operating Hours",
  };

  const PwdRequirement = ({ met, label }) => (
    <FormControlLabel
      control={
        <Checkbox
          checked={met}
          color={met ? "success" : "error"}
          size="small"
          readOnly
          tabIndex={-1}
        />
      }
      label={label}
      labelPlacement="end"
      disableTypography
      sx={{
        color: met ? "#2e7d32" : "#d32f2f",
        display: "flex",
        cursor: "default",
        pointerEvents: "none",
      }}
    />
  );

  return (
    <Box
      className="signup-form-box"
      onKeyDown={(e) => {
        if (e.key === "Enter" && e.target.tagName === "INPUT") handleAdvance();
      }}
    >
      <Stepper activeStep={activeStep} sx={{ mb: 3 }} alternativeLabel>
        {STEPS.map((label, i) => (
          <Step key={i}>
            <StepLabel>{label}</StepLabel>
          </Step>
        ))}
      </Stepper>

      <Grid container spacing={2} textAlign="center">
        <Grid item xs={12}>
          <Typography variant="h6">{stepTitles[activeStep]}</Typography>
        </Grid>

        {activeStep === 0 && (
          <Grid item xs={12}>
            <div className="inputs-card">
              <TextField
                label="Restaurant Name"
                required
                fullWidth
                size="small"
                value={restaurantName}
                onChange={(e) => setRestaurantName(e.target.value)}
                error={reqErr(restaurantName)}
                helperText={reqMsg(restaurantName)}
              />
              <TextField
                label="Zip Code"
                required
                fullWidth
                size="small"
                value={restaurantZip}
                onChange={handleRestaurantZipChange}
                error={restaurantZipError || reqErr(restaurantZip)}
                helperText={
                  restaurantZipError ? zipErrorContent : reqMsg(restaurantZip)
                }
              />
            </div>
          </Grid>
        )}

        {activeStep === 1 && (
          <Grid item xs={12}>
            <div className="inputs-card">
              <TextField
                label="Email"
                type="email"
                required
                fullWidth
                size="small"
                value={email}
                onChange={handleEmailChange}
                error={emailError || reqErr(email)}
                helperText={
                  reqMsg(email) ||
                  (emailError ? "Enter a valid email address" : "")
                }
              />
              <TextField
                label="Phone Number"
                type="tel"
                required
                fullWidth
                size="small"
                value={phone}
                onChange={(e) => setPhone(e.target.value)}
                error={reqErr(phone)}
                helperText={reqMsg(phone)}
              />
              <TextField
                label="Password"
                type={pwdVisible ? "text" : "password"}
                required
                fullWidth
                size="small"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                error={
                  reqErr(password) ||
                  (showErrors && !isPasswordValid(password, email))
                }
                helperText={reqMsg(password)}
                InputProps={{
                  endAdornment: (
                    <InputAdornment position="end">
                      <IconButton
                        onClick={() => setPwdVisible(!pwdVisible)}
                        tabIndex={-1}
                      >
                        {pwdVisible ? (
                          <VisibilityOffIcon />
                        ) : (
                          <VisibilityIcon />
                        )}
                      </IconButton>
                    </InputAdornment>
                  ),
                }}
              />
              {password.length > 0 && (
                <>
                  <Divider />
                  <Box sx={{ textAlign: "left", fontSize: "0.85rem" }}>
                    <Typography
                      variant="caption"
                      fontWeight={600}
                      display="block"
                      mb={0.5}
                    >
                      Password must:
                    </Typography>
                    <PwdRequirement
                      met={isPwdLongEnough(password)}
                      label="Be at least 8 characters long"
                    />
                    <PwdRequirement
                      met={isPwdNotOnlyNumbers(password)}
                      label="Not only contain numbers"
                    />
                    <PwdRequirement
                      met={isPwdNotCommon(password)}
                      label={'Not be a common word (eg "password")'}
                    />
                    <PwdRequirement
                      met={isPwdNotSimilarToEmail(password, email)}
                      label="Not be too similar to your email"
                    />
                  </Box>
                  <Divider />
                </>
              )}
              <TextField
                label="Confirm Password"
                type={confirmPwdVisible ? "text" : "password"}
                required
                fullWidth
                size="small"
                value={confirmPassword}
                onChange={(e) => setConfirmPassword(e.target.value)}
                error={confirmPasswordError || reqErr(confirmPassword)}
                helperText={
                  reqMsg(confirmPassword) ||
                  (confirmPasswordError ? "Passwords do not match" : "")
                }
                InputProps={{
                  endAdornment: (
                    <InputAdornment position="end">
                      <IconButton
                        onClick={() => setConfirmPwdVisible(!confirmPwdVisible)}
                        tabIndex={-1}
                      >
                        {confirmPwdVisible ? (
                          <VisibilityOffIcon />
                        ) : (
                          <VisibilityIcon />
                        )}
                      </IconButton>
                    </InputAdornment>
                  ),
                }}
              />
            </div>
          </Grid>
        )}

        {activeStep === 2 && (
          <Grid item xs={12}>
            <div className="inputs-card">
              <Typography variant="subtitle2" textAlign="left">
                Shipping Address
              </Typography>
              <TextField
                label="Address Line 1"
                required
                fullWidth
                size="small"
                value={shippingAddress.address_line1}
                onChange={handleShippingChange("address_line1")}
                error={reqErr(shippingAddress.address_line1)}
                helperText={reqMsg(shippingAddress.address_line1)}
              />
              <TextField
                label="Address Line 2"
                fullWidth
                size="small"
                value={shippingAddress.address_line2}
                onChange={handleShippingChange("address_line2")}
                error={reqErr(shippingAddress.address_line2)}
                helperText={reqMsg(shippingAddress.address_line2)}
              />
              <Box sx={{ display: "flex", gap: 1 }}>
                <TextField
                  label="City"
                  required
                  fullWidth
                  size="small"
                  value={shippingAddress.city}
                  onChange={handleShippingChange("city")}
                  error={reqErr(shippingAddress.city)}
                  helperText={reqMsg(shippingAddress.city)}
                />
                <TextField
                  label="State"
                  required
                  fullWidth
                  size="small"
                  value={shippingAddress.state}
                  onChange={handleShippingChange("state")}
                  error={reqErr(shippingAddress.state)}
                  helperText={reqMsg(shippingAddress.state)}
                />
                <TextField
                  label="Zip"
                  required
                  fullWidth
                  size="small"
                  value={shippingAddress.zip}
                  onChange={handleShippingChange("zip")}
                  error={shippingZipError || reqErr(shippingAddress.zip)}
                  helperText={
                    shippingZipError
                      ? zipErrorContent
                      : reqMsg(shippingAddress.zip)
                  }
                />
              </Box>
              <FormControlLabel
                sx={{ alignSelf: "flex-start" }}
                control={
                  <Checkbox
                    checked={billingSameAsShipping}
                    onChange={handleBillingSameToggle}
                    color="primary"
                  />
                }
                label={
                  <Typography variant="body2">
                    Billing address same as shipping
                  </Typography>
                }
              />
              {!billingSameAsShipping && (
                <>
                  <Typography variant="subtitle2" textAlign="left">
                    Billing Address
                  </Typography>
                  <TextField
                    label="Address Line 1"
                    required
                    fullWidth
                    size="small"
                    value={billingAddress.address_line1}
                    onChange={(e) =>
                      setBillingAddress({
                        ...billingAddress,
                        address_line1: e.target.value,
                      })
                    }
                    error={reqErr(billingAddress.address_line1)}
                    helperText={reqMsg(billingAddress.address_line1)}
                  />
                  <TextField
                    label="Address Line 2"
                    fullWidth
                    size="small"
                    value={billingAddress.address_line2}
                    onChange={(e) =>
                      setBillingAddress({
                        ...billingAddress,
                        address_line2: e.target.value,
                      })
                    }
                    error={reqErr(billingAddress.address_line2)}
                    helperText={reqMsg(billingAddress.address_line2)}
                  />
                  <Box sx={{ display: "flex", gap: 1 }}>
                    <TextField
                      label="City"
                      required
                      fullWidth
                      size="small"
                      value={billingAddress.city}
                      onChange={(e) =>
                        setBillingAddress({
                          ...billingAddress,
                          city: e.target.value,
                        })
                      }
                      error={reqErr(billingAddress.city)}
                      helperText={reqMsg(billingAddress.city)}
                    />
                    <TextField
                      label="State"
                      required
                      fullWidth
                      size="small"
                      value={billingAddress.state}
                      onChange={(e) =>
                        setBillingAddress({
                          ...billingAddress,
                          state: e.target.value,
                        })
                      }
                      error={reqErr(billingAddress.state)}
                      helperText={reqMsg(billingAddress.state)}
                    />
                    <TextField
                      label="Zip"
                      required
                      fullWidth
                      size="small"
                      value={billingAddress.zip}
                      onChange={(e) =>
                        setBillingAddress({
                          ...billingAddress,
                          zip: e.target.value,
                        })
                      }
                      error={reqErr(billingAddress.zip)}
                      helperText={reqMsg(billingAddress.zip)}
                    />
                  </Box>
                </>
              )}
            </div>
          </Grid>
        )}

        {activeStep === 3 && (
          <Grid item xs={12}>
            <div className="inputs-card">
              <OperatingHours
                value={operatingHours}
                onChange={setOperatingHours}
              />
            </div>
          </Grid>
        )}

        {submitError && (
          <Grid item xs={12}>
            <Alert severity="error" sx={{ whiteSpace: "pre-line" }}>
              {submitError}
            </Alert>
          </Grid>
        )}

        <Grid item xs={12}>
          <Typography variant="caption" color="text.secondary">
            * Email verification required. Check your email after signing up.
          </Typography>
          <Box
            sx={{
              display: "flex",
              justifyContent: "space-between",
              mt: 1,
              width: "80%",
              mx: "auto",
            }}
          >
            <Button
              variant="text"
              color="inherit"
              disabled={activeStep === 0}
              onClick={handleBack}
            >
              Back
            </Button>
            {activeStep < STEPS.length - 1 ? (
              <Button
                variant="contained"
                color="primary"
                onClick={handleNext}
                disabled={!stepValid()}
              >
                Next
              </Button>
            ) : (
              <Button
                variant="contained"
                color="primary"
                onClick={handleSubmit}
                disabled={saving || !stepValid()}
              >
                Create Account
              </Button>
            )}
          </Box>
        </Grid>

        <Grid item xs={12}>
          <ContactInfo />
          <Divider sx={{ mt: 1 }} />
          <Typography variant="body2" color="text.secondary" sx={{ mt: 1 }}>
            Already have an account?{" "}
            <Button
              color="primary"
              size="small"
              onClick={handleSwitchToSignIn}
              sx={{ textTransform: "none", p: 0, minWidth: "auto" }}
            >
              Sign In
            </Button>
          </Typography>
        </Grid>
      </Grid>

      <Snackbar
        open={!!snackMessage}
        autoHideDuration={2500}
        onClose={() => setSnackMessage("")}
        message={snackMessage}
      />

      <Dialog
        open={confirmLeaveOpen}
        onClose={() => setConfirmLeaveOpen(false)}
      >
        <DialogTitle>Leave sign up?</DialogTitle>
        <DialogContent>
          <DialogContentText>
            Your progress will be lost. Are you sure you want to go back to sign
            in?
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setConfirmLeaveOpen(false)}>Stay</Button>
          <Button
            onClick={handleConfirmLeave}
            color="primary"
            variant="contained"
          >
            Yes, go back
          </Button>
        </DialogActions>
      </Dialog>
    </Box>
  );
};

export default SignUpForm;
